export const iplDateSlateArray = {
  "2021-04-09": ["20210409MIRCB11"],
  "2021-04-10": ["20210410CSKDC11"],
  "2021-04-11": ["20210411SRHKKR11"],
  "2021-04-12": ["20210412RRPBKS11"],
  "2021-04-13": ["20210413KKRMI11"],
  "2021-04-14": ["20210414SRHRCB11"],
  "2021-04-15": ["20210415RRDC11"],
  "2021-04-16": ["20210416PBKSCSK11"],
  "2021-04-17": ["20210417MISRH11"],
  "2021-04-18": ["20210418DCPBKS11", "20210418RCBKKR11"],
  "2021-04-19": ["20210419CSKRR11"],
  "2021-04-20": ["20210420DCMI11"],
  "2021-04-21": ["20210421PBKSSRH11", "20210421KKRCSK11"],
  "2021-04-22": ["20210422RCBRR11"],
  "2021-04-23": ["20210423PBKSMI11"],
  "2021-04-24": ["20210424RRKKR11"],
  "2021-04-25": ["20210425CSKRCB11", "20210425SRHDC11"],
  "2021-04-26": ["20210426PBKSKKR11"],
  "2021-04-27": ["20210427DCRCB11"],
  "2021-04-28": ["20210428CSKSRH11"],
  "2021-04-29": ["20210429MIRR11", "20210429DCKKR11"],
  "2021-04-30": ["20210430PBKSRCB11"],
  "2021-05-1": ["20210501MICSK11"],
  "2021-05-2": ["20210502RRSRH11", "20210502PBKSDC11"],
  "2021-05-3": ["20210503KKRRCB11"],
  "2021-05-4": ["20210504SRHMI11"],
  "2021-05-5": ["20210505RRCSK11"],
  "2021-05-6": ["20210506RCBPBKS11"],
  "2021-05-7": ["20210507SRHCSK11"],
  "2021-05-8": ["20210508KKRDC11", "20210508RRMI11"],
  "2021-05-9": ["20210509CSKPBKS11", "20210509RCBSRH11"],
  "2021-05-10": ["20210510MIKKR11"],
  "2021-05-11": ["20210511DCRR11"],
  "2021-05-12": ["20210512CSKKKR11"],
  "2021-05-13": ["20210513MIPBKS11", "20210513SRHRR11"],
  "2021-05-14": ["20210514RCBDC11"],
  "2021-05-15": ["20210515KKRPBKS11"],
  "2021-05-16": ["20210516RRRCB11", "20210516CSKMI11"],
  "2021-05-17": ["20210517DCSRH11"],
  "2021-05-18": ["20210518KKRRR11"],
  "2021-05-19": ["20210519SRHPBKS11"],
  "2021-05-20": ["20210520RCBMI11"],
  "2021-05-21": ["20210521KKRSRH11", "20210521DCCSK11"],
  "2021-05-22": ["20210522PBKSRR11"],
  "2021-05-23": ["20210523MIDC11", "20210523RCBCSK11"],
};

export const iplDateGameDateTimeInfo = {
  "2021-04-09": ["2021-04-09T19:30:00+05:30"],
  "2021-04-10": ["2021-04-10T19:30:00+05:30"],
  "2021-04-11": ["2021-04-11T19:30:00+05:30"],
  "2021-04-12": ["2021-04-12T19:30:00+05:30"],
  "2021-04-13": ["2021-04-13T19:30:00+05:30"],
  "2021-04-14": ["2021-04-14T19:30:00+05:30"],
  "2021-04-15": ["2021-04-15T19:30:00+05:30"],
  "2021-04-16": ["2021-04-16T19:30:00+05:30"],
  "2021-04-17": ["2021-04-17T19:30:00+05:30"],
  "2021-04-18": ["2021-04-18T15:30:00+05:30", "2021-04-18T19:30:00+05:30"],
  "2021-04-19": ["2021-04-19T19:30:00+05:30"],
  "2021-04-20": ["2021-04-20T19:30:00+05:30"],
  "2021-04-21": ["2021-04-21T15:30:00+05:30", "2021-04-21T19:30:00+05:30"],
  "2021-04-22": ["2021-04-22T19:30:00+05:30"],
  "2021-04-23": ["2021-04-23T19:30:00+05:30"],
  "2021-04-24": ["2021-04-24T19:30:00+05:30"],
  "2021-04-25": ["2021-04-25T15:30:00+05:30", "2021-04-25T19:30:00+05:30"],
  "2021-04-26": ["2021-04-26T19:30:00+05:30"],
  "2021-04-27": ["2021-04-27T19:30:00+05:30"],
  "2021-04-28": ["2021-04-28T19:30:00+05:30"],
  "2021-04-29": ["2021-04-29T15:30:00+05:30", "2021-04-29T19:30:00+05:30"],
  "2021-04-30": ["2021-04-30T19:30:00+05:30"],
  "2021-05-1": ["2021-05-01T19:30:00+05:30"],
  "2021-05-2": ["2021-05-02T15:30:00+05:30", "2021-05-02T19:30:00+05:30"],
  "2021-05-3": ["2021-05-03T19:30:00+05:30"],
  "2021-05-4": ["2021-05-04T19:30:00+05:30"],
  "2021-05-5": ["2021-05-05T19:30:00+05:30"],
  "2021-05-6": ["2021-05-06T19:30:00+05:30"],
  "2021-05-7": ["2021-05-07T19:30:00+05:30"],
  "2021-05-8": ["2021-05-08T15:30:00+05:30", "2021-05-08T19:30:00+05:30"],
  "2021-05-9": ["2021-05-09T15:30:00+05:30", "2021-05-09T19:30:00+05:30"],
  "2021-05-10": ["2021-05-10T19:30:00+05:30"],
  "2021-05-11": ["2021-05-11T19:30:00+05:30"],
  "2021-05-12": ["2021-05-12T19:30:00+05:30"],
  "2021-05-13": ["2021-05-13T15:30:00+05:30", "2021-05-13T19:30:00+05:30"],
  "2021-05-14": ["2021-05-14T19:30:00+05:30"],
  "2021-05-15": ["2021-05-15T19:30:00+05:30"],
  "2021-05-16": ["2021-05-16T15:30:00+05:30", "2021-05-16T19:30:00+05:30"],
  "2021-05-17": ["2021-05-17T19:30:00+05:30"],
  "2021-05-18": ["2021-05-18T19:30:00+05:30"],
  "2021-05-19": ["2021-05-19T19:30:00+05:30"],
  "2021-05-20": ["2021-05-20T19:30:00+05:30"],
  "2021-05-21": ["2021-05-21T15:30:00+05:30", "2021-05-21T19:30:00+05:30"],
  "2021-05-22": ["2021-05-22T19:30:00+05:30"],
  "2021-05-23": ["2021-05-23T15:30:00+05:30", "2021-05-23T19:30:00+05:30"],
  "2021-05-25": ["2021-05-25T19:30:00+05:30"],
  "2021-05-26": ["2021-05-26T19:30:00+05:30"],
  "2021-05-28": ["2021-05-28T19:30:00+05:30"],
  "2021-05-30": ["2021-05-30T19:30:00+05:30"],
};

export const iplGameIDDatatimeInfo = {
  "20210409MIRCB11": "2021-04-09T19:30:00+05:30",
  "20210410CSKDC11": "2021-04-10T19:30:00+05:30",
  "20210411SRHKKR11": "2021-04-11T19:30:00+05:30",
  "20210412RRPBKS11": "2021-04-12T19:30:00+05:30",
  "20210413KKRMI11": "2021-04-13T19:30:00+05:30",
  "20210414SRHRCB11": "2021-04-14T19:30:00+05:30",
  "20210415RRDC11": "2021-04-15T19:30:00+05:30",
  "20210416PBKSCSK11": "2021-04-16T19:30:00+05:30",
  "20210417MISRH11": "2021-04-17T19:30:00+05:30",
  "20210418RCBKKR11": "2021-04-18T15:30:00+05:30",
  "20210418DCPBKS11": "2021-04-18T19:30:00+05:30",
  "20210419CSKRR11": "2021-04-19T19:30:00+05:30",
  "20210420DCMI11": "2021-04-20T19:30:00+05:30",
  "20210421PBKSSRH11": "2021-04-21T15:30:00+05:30",
  "20210421KKRCSK11": "2021-04-21T19:30:00+05:30",
  "20210422RCBRR11": "2021-04-22T19:30:00+05:30",
  "20210423PBKSMI11": "2021-04-23T19:30:00+05:30",
  "20210424RRKKR11": "2021-04-24T19:30:00+05:30",
  "20210425CSKRCB11": "2021-04-25T15:30:00+05:30",
  "20210425SRHDC11": "2021-04-25T19:30:00+05:30",
  "20210426PBKSKKR11": "2021-04-26T19:30:00+05:30",
  "20210427DCRCB11": "2021-04-27T19:30:00+05:30",
  "20210428CSKSRH11": "2021-04-28T19:30:00+05:30",
  "20210429MIRR11": "2021-04-29T15:30:00+05:30",
  "20210429DCKKR11": "2021-04-29T19:30:00+05:30",
  "20210430PBKSRCB11": "2021-04-30T19:30:00+05:30",
  "20210501MICSK11": "2021-05-01T19:30:00+05:30",
  "20210502RRSRH11": "2021-05-02T15:30:00+05:30",
  "20210502PBKSDC11": "2021-05-02T19:30:00+05:30",
  "20210503KKRRCB11": "2021-05-03T19:30:00+05:30",
  "20210504SRHMI11": "2021-05-04T19:30:00+05:30",
  "20210505RRCSK11": "2021-05-05T19:30:00+05:30",
  "20210506RCBPBKS11": "2021-05-06T19:30:00+05:30",
  "20210507SRHCSK11": "2021-05-07T19:30:00+05:30",
  "20210508KKRDC11": "2021-05-08T15:30:00+05:30",
  "20210508RRMI11": "2021-05-08T19:30:00+05:30",
  "20210509CSKPBKS11": "2021-05-09T15:30:00+05:30",
  "20210509RCBSRH11": "2021-05-09T19:30:00+05:30",
  "20210510MIKKR11": "2021-05-10T19:30:00+05:30",
  "20210511DCRR11": "2021-05-11T19:30:00+05:30",
  "20210512CSKKKR11": "2021-05-12T19:30:00+05:30",
  "20210513MIPBKS11": "2021-05-13T15:30:00+05:30",
  "20210513SRHRR11": "2021-05-13T19:30:00+05:30",
  "20210514RCBDC11": "2021-05-14T19:30:00+05:30",
  "20210515KKRPBKS11": "2021-05-15T19:30:00+05:30",
  "20210516RRRCB11": "2021-05-16T15:30:00+05:30",
  "20210516CSKMI11": "2021-05-16T19:30:00+05:30",
  "20210517DCSRH11": "2021-05-17T19:30:00+05:30",
  "20210518KKRRR11": "2021-05-18T19:30:00+05:30",
  "20210519SRHPBKS11": "2021-05-19T19:30:00+05:30",
  "20210520RCBMI11": "2021-05-20T19:30:00+05:30",
  "20210521KKRSRH11": "2021-05-21T15:30:00+05:30",
  "20210521DCCSK11": "2021-05-21T19:30:00+05:30",
  "20210522PBKSRR11": "2021-05-22T19:30:00+05:30",
  "20210523MIDC11": "2021-05-23T15:30:00+05:30",
  "20210523RCBCSK11": "2021-05-23T19:30:00+05:30",
  "20210525TBCTBC11": "2021-05-25T19:30:00+05:30",
  "20210526TBCTBC11": "2021-05-26T19:30:00+05:30",
  "20210528TBCTBC11": "2021-05-28T19:30:00+05:30",
  "20210530TBCTBC11": "2021-05-30T19:30:00+05:30",
};
export const pslGameIDDatatimeInfo = {
  "20210220KKQG11": "2021-02-20T19:00:00+05:00",
  "20210221LQPZ11": "2021-02-21T14:00:00+05:00",
  "20210221IUMS11": "2021-02-21T19:00:00+05:00",
  "20210222LQQG11": "2021-02-22T19:00:00+05:00",
  "20210223MSPZ11": "2021-02-23T19:00:00+05:00",
  "20210224KKIU11": "2021-02-24T19:00:00+05:00",
  "20210226LQMS11": "2021-02-26T15:00:00+05:00",
  "20210226PZQG11": "2021-02-26T20:00:00+05:00",
  "20210227KKMS11": "2021-02-27T14:00:00+05:00",
  "20210227IUPZ11": "2021-02-27T19:00:00+05:00",
  "20210228KKLQ11": "2021-02-28T19:00:00+05:00",
  "20210301IUQG11": "2021-03-01T19:00:00+05:00",
  "20210303KKPZ11": "2021-03-03T14:00:00+05:00",
  "20210303MSQG11": "2021-03-03T19:00:00+05:00",
  "20210609IULQ11": "2021-06-09T20:00:00+04:00",
  "20210610KKMS11": "2021-06-10T17:00:00+04:00",
  "20210610LQPZ11": "2021-06-10T22:00:00+04:00",
  "20210611IUQG11": "2021-06-11T20:00:00+04:00",
  "20210612PZQG11": "2021-06-12T20:00:00+04:00",
  "20210613IULQ11": "2021-06-13T17:00:00+04:00",
  "20210613MSPZ11": "2021-06-13T22:00:00+04:00",
  "20210614IUKK11": "2021-06-14T20:00:00+04:00",
  "20210615LQQG11": "2021-06-15T17:00:00+04:00",
  "20210615KKPZ11": "2021-06-15T22:00:00+04:00",
  "20210616MSQG11": "2021-06-16T20:00:00+04:00",
  "20210617IUPZ11": "2021-06-17T17:00:00+04:00",
  "20210617KKLQ11": "2021-06-17T22:00:00+04:00",
  "20210618LQMS11": "2021-06-18T20:00:00+04:00",
  "20210619KKQG11": "2021-06-19T17:00:00+04:00",
  "20210619IUMS11": "2021-06-19T22:00:00+04:00",
  "20210621IUMS11": "2021-06-21T17:00:00+04:00",
  "20210621PZKK11": "2021-06-21T22:00:00+04:00",
  "20210622IUPZ11": "2021-06-22T20:00:00+04:00",
  "20210624MSPZ11": "2021-06-24T20:00:00+04:00",
  "20210630MSPZ11": "2021-06-30T20:00:00+04:00",
};
export const pslDateGameDateTimeInfo = {
  "2021-02-20": ["2021-02-20T19:00:00+05:00"],
  "2021-02-21": ["2021-02-21T14:00:00+05:00", "2021-02-21T19:00:00+05:00"],
  "2021-02-22": ["2021-02-22T19:00:00+05:00"],
  "2021-02-23": ["2021-02-23T19:00:00+05:00"],
  "2021-02-24": ["2021-02-24T19:00:00+05:00"],
  "2021-02-26": ["2021-02-26T15:00:00+05:00", "2021-02-26T20:00:00+05:00"],
  "2021-02-27": ["2021-02-27T14:00:00+05:00", "2021-02-27T19:00:00+05:00"],
  "2021-02-28": ["2021-02-28T19:00:00+05:00"],
  "2021-03-01": ["2021-03-01T19:00:00+05:00"],
  "2021-03-03": ["2021-03-03T14:00:00+05:00", "2021-03-03T19:00:00+05:00"],
  "2021-06-09": ["2021-06-09T20:00:00+04:00"],
  "2021-06-10": ["2021-06-10T17:00:00+04:00", "2021-06-10T22:00:00+04:00"],
  "2021-06-11": ["2021-06-11T20:00:00+04:00"],
  "2021-06-12": ["2021-06-12T20:00:00+04:00"],
  "2021-06-13": ["2021-06-13T17:00:00+04:00", "2021-06-13T22:00:00+04:00"],
  "2021-06-14": ["2021-06-14T20:00:00+04:00"],
  "2021-06-15": ["2021-06-15T17:00:00+04:00", "2021-06-15T22:00:00+04:00"],
  "2021-06-16": ["2021-06-16T20:00:00+04:00"],
  "2021-06-17": ["2021-06-17T17:00:00+04:00", "2021-06-17T22:00:00+04:00"],
  "2021-06-18": ["2021-06-18T20:00:00+04:00"],
  "2021-06-19": ["2021-06-19T17:00:00+04:00", "2021-06-19T22:00:00+04:00"],
  "2021-06-21": ["2021-06-21T17:00:00+04:00", "2021-06-21T22:00:00+04:00"],
  "2021-06-22": ["2021-06-22T20:00:00+04:00"],
  "2021-06-24": ["2021-06-24T20:00:00+04:00"],
  "2021-06-30": ["2021-06-30T20:00:00+04:00"],
};

export const pslDateSlateArray = {
  "2021-02-20": ["20210220KKQG11"],
  "2021-02-21": ["20210221IUMS11", "20210221LQPZ11"],
  "2021-02-22": ["20210222LQQG11"],
  "2021-02-23": ["20210223MSPZ11"],
  "2021-02-24": ["20210224KKIU11"],
  "2021-02-26": ["20210226PZQG11", "20210226LQMS11"],
  "2021-02-27": ["20210227IUPZ11", "20210227KKMS11"],
  "2021-02-28": ["20210228KKLQ11"],
  "2021-03-01": ["20210301IUQG11"],
  "2021-03-03": ["20210303MSQG11", "20210303KKPZ11"],
  "2021-06-09": ["20210609IULQ11"],
  "2021-06-10": ["20210610KKMS11", "20210610LQPZ11"],
  "2021-06-11": ["20210611IUQG11"],
  "2021-06-12": ["20210612PZQG11"],
  "2021-06-13": ["20210613MSPZ11", "20210613IULQ11"],
  "2021-06-14": ["20210614IUKK11"],
  "2021-06-15": ["20210615LQQG11", "20210615KKPZ11"],
  "2021-06-16": ["20210616MSQG11"],
  "2021-06-17": ["20210617IUPZ11", "20210617KKLQ11"],
  "2021-06-18": ["20210618LQMS11"],
  "2021-06-19": ["20210619KKQG11", "20210619IUMS11"],
  "2021-06-21": ["20210621IUMS11", "20210621PZKK11"],
  "2021-06-22": ["20210622IUPZ11"],
  "2021-06-24": ["20210624MSPZ11"],
  "2021-06-30": ["20210630MSPZ11"],
};

export const vbDateSlateArray = {
  "2021-07-09": [ "20210709GLOUCMIDDX11", "20210709WORCSBEARS11",
                  "20210709DURHDERBS11", "20210709LANCSNHNTS11",
                  "20210709NOTTSYORKS11", "20210709SURRKENT11",
                  "20210709HANTSSOM11", "20210709SUSSESSEX11" ],
  "2021-07-16" : ["20210716HANTSESSEX11", "20210716GLOUCSURR11",
                  "20210716MIDDXKENT11", "20210716BEARSWORCS11",
                  "20210716GLAMSOM11", "20210716LANCSDURH11",
                  "20210716LEICSNOTTS11", "20210716NHNTSDERBS11",
                  "20210716HANTSSUSS11" ],
  "2021-07-17" : ["20210717LANCSYORKS11"],
  "2021-07-18" : ["20210718BEARSNHNTS11", "20210718DERBSYORKS11",
                  "20210718ESSEXMIDDX11", "20210718HANTSGLAM11",
                  "20210718KENTSUSS11", "20210718LEICSWORCS11",
                  "20210718NOTTSDURH11", "20210718SOMGLOUC11"],
};

export const vbDateGameDateTimeInfo = {
  "2021-07-09": [ "2021-07-09T14:30:00+01:00", "2021-07-09T17:30:00+01:00",
                  "2021-07-09T18:30:00+01:00", "2021-07-09T18:30:00+01:00",
                  "2021-07-09T18:30:00+01:00", "2021-07-09T18:30:00+01:00",
                  "2021-07-09T19:00:00+01:00", "2021-07-09T19:00:00+01:00"],
  "2021-07-16" : ["2021-07-16T14:00:00+01:00", "2021-07-16T14:30:00+01:00",
                  "2021-07-16T18:15:00+01:00", "2021-07-16T18:30:00+01:00",
                  "2021-07-16T18:30:00+01:00", "2021-07-16T18:30:00+01:00",
                  "2021-07-16T18:30:00+01:00", "2021-07-16T18:30:00+01:00",
                  "2021-07-16T19:00:00+01:00"],
  "2021-07-17" : [ "2021-07-17T17:00:00+01:00"],
  "2021-07-18" : ["2021-07-18T14:30:00+01:00", "2021-07-18T14:30:00+01:00",
                  "2021-07-18T14:30:00+01:00", "2021-07-18T14:30:00+01:00",
                  "2021-07-18T14:30:00+01:00", "2021-07-18T14:30:00+01:00",
                  "2021-07-18T14:30:00+01:00", "2021-07-18T14:30:00+01:00"]
};

export const vbGameIDDatatimeInfo = {
  "20210709GLOUCMIDDX11": "2021-07-09T14:30:00+01:00",
  "20210709WORCSBEARS11": "2021-07-09T17:30:00+01:00",
  "20210709DURHDERBS11": "2021-07-09T18:30:00+01:00",
  "20210709LANCSNHNTS11": "2021-07-09T18:30:00+01:00",
  "20210709NOTTSYORKS11": "2021-07-09T18:30:00+01:00",
  "20210709SURRKENT11": "2021-07-09T18:30:00+01:00",
  "20210709HANTSSOM11": "2021-07-09T19:00:00+01:00",
  "20210709SUSSESSEX11": "2021-07-09T19:00:00+01:00",
  "20210716HANTSESSEX11": "2021-07-16T14:00:00+01:00",
  "20210716GLOUCSURR11": "2021-07-16T14:30:00+01:00",
  "20210716MIDDXKENT11": "2021-07-16T18:15:00+01:00",
  "20210716BEARSWORCS11": "2021-07-16T18:30:00+01:00",
  "20210716GLAMSOM11": "2021-07-16T18:30:00+01:00",
  "20210716LANCSDURH11": "2021-07-16T18:30:00+01:00",
  "20210716LEICSNOTTS11": "2021-07-16T18:30:00+01:00",
  "20210716NHNTSDERBS11": "2021-07-16T18:30:00+01:00",
  "20210716HANTSSUSS11": "2021-07-16T19:00:00+01:00",
  "20210717LANCSYORKS11": "2021-07-17T17:00:00+01:00",
  "20210718BEARSNHNTS11": "2021-07-18T14:30:00+01:00",
  "20210718DERBSYORKS11": "2021-07-18T14:30:00+01:00",
  "20210718ESSEXMIDDX11": "2021-07-18T14:30:00+01:00",
  "20210718HANTSGLAM11": "2021-07-18T14:30:00+01:00",
  "20210718KENTSUSS11": "2021-07-18T14:30:00+01:00",
  "20210718LEICSWORCS11": "2021-07-18T14:30:00+01:00",
  "20210718NOTTSDURH11": "2021-07-18T14:30:00+01:00",
  "20210718SOMGLOUC11": "2021-07-18T14:30:00+01:00"
};
